import React, { useMemo, useState, useEffect } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useAreaUIContext } from "../AreaUIContext";
import { initialFilter } from "../AreaUIHelpers";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { getPeriodeKurbanAll } from "../../../Donation/_redux/periode-kurban/periodeKurbanCrud";

const prepareFilter = (queryParams, values) => {
  const { name, thk_period_uuid } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  filter.thk_period_uuid = thk_period_uuid ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const AreaFilter = ({ listLoading }) => {
  // Area UI Context
  const areaUIContext = useAreaUIContext();
  const areaUIProps = useMemo(() => {
    return {
      setQueryParams: areaUIContext.setQueryParams,
      queryParams: areaUIContext.queryParams,
      filterType: areaUIContext.filterType,
    };
  }, [areaUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(areaUIProps.queryParams, values);
    if (!isEqual(newQueryParams, areaUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      areaUIProps.setQueryParams(newQueryParams);
    }
  };

  const [options, setOptions] = useState({
    thk_period: [],
  });

  useEffect(() => {
    getPeriodeKurbanAll().then((res) => {
      setOptions((prev) => ({
        ...prev,
        thk_period: res.data.data,
      }));
    });
  }, []);

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Search"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                }}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Berdasarkan Nama Opsi
              </small>
            </div>
            <div className="col-lg-4">
              <Autocomplete
                name="thk_period_uuid"
                options={options.thk_period}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => {
                  if (value) {
                    setFieldValue("thk_period_uuid", value.uuid);
                  } else {
                    setFieldValue("thk_period_uuid", "");
                  }
                }}
                value={
                  options.thk_period.length > 0 &&
                  options.thk_period.find(
                    (item) => item.uuid === values.thk_period_uuid
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Pilih Periode"
                    variant="outlined"
                    disableClearable
                    size="small"
                  />
                )}
              />
              <small className="form-text text-muted">
                <b>Cari</b> Periode
              </small>
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
